import React from 'react'
import PropTypes from 'prop-types'
import 'styles/core.scss'

export const CoreLayout = ({ classes, children }) => (
  <div className={classes.container}>
    <div className={classes.children}>{children}</div>
  </div>
)

CoreLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js